<script lang="ts">
import SubTopic from "./subTopic.vue";
import airline from '@/assets/images/home/home-img-1.png';
import { useRouter } from "vue-router";
import { MainTopic } from "@/interface/MainTopic.interface";
import ConfirmDialog from "@/app/common/components/ConfirmDialog.vue";
import { REQUEST_STATUS } from "@/app/const";
import { useSharedDataStore } from "@/store/app";
import { complaintService } from "@/services/serviceProvider";

export default {
    setup() {
        const router = useRouter();
        const store = useSharedDataStore();

        return {
            router, store
        };
    },
    components: { SubTopic, ConfirmDialog },
    props: {
        modelValue: {
            type: Object,
            default: undefined
        },
        mainTopicId: {
            type: Number,
            default: undefined
        },
        subTopicId: {
            type: Number,
            default: undefined
        },
    },
    data() {
        return {
            displayConfirmDialog: false,
            displaySubTopic: false,
            mainTopicSelected: undefined as MainTopic | undefined,
            subTopicSelectedId: this.subTopicId as number | undefined,
            subTopicSelectedDesc: undefined as string | undefined,
            prevRequestNo: undefined as string | undefined,
        };
    },
    watch: {
        async mainTopicId(newVal, oldVal) {
            await this.getMainTopic();
            this.displaySubTopicDialog(true);
        },
        async subTopicId(newVal, oldVal) {
            if (newVal) {
                await this.getMainTopic();
                this.displaySubTopicDialog(true);
            } else {
                this.subTopicSelectedId = undefined;
                this.subTopicSelectedDesc = undefined;
            }
        }
    },
    async mounted() {
        if (this.mainTopicId)
            await this.getMainTopic();
    },
    computed: {
        async prevRequest() {
            const requests = await complaintService.getAllUserRequests();
            const req = requests.data?.find(o => o.mainId === this.mainTopicSelected?.id
                && o.subId === this.subTopicSelectedId
                && o.status === REQUEST_STATUS.DRAFT);
            this.prevRequestNo = req?.requestNo;
            return req;
        }
    },
    methods: {
        async getMainTopic() {
            try {
                if (this.mainTopicId) {
                    const res = await complaintService.getMainById((this.mainTopicId).toString());
                    if (res && res.status === 200) {
                        this.mainTopicSelected = res.data as MainTopic;
                        this.mainTopicSelected.id = this.mainTopicId;
                        if (!this.mainTopicSelected.imageUrl) this.mainTopicSelected.imageUrl = airline
                        if (this.subTopicId) {
                            let sub = this.mainTopicSelected.subTopics?.find(o => o.id === this.subTopicId);
                            this.subTopicSelectedId = sub?.id;
                            this.subTopicSelectedDesc = sub?.formInfo.guidelines;
                        }
                    }
                }
            } catch (e) {
            }
        },
        updateSubTopicSelectedId(value: any) {
            this.subTopicSelectedId = value;
        },
        async checkPreviousRequest() {
            const havePreviousRequest = await this.prevRequest;
            if (havePreviousRequest) {
                this.displayConfirmDialog = true;
            } else {
                this.goCreateComplaint();
            }
        },
        async goCreateComplaint() {
            if (this.mainTopicSelected)
                this.router.push({ path: `/complaint/${this.mainTopicSelected.id}/${this.subTopicSelectedId}` });
        },
        async goContinueComplaint() {
            const request = await this.prevRequest;
            const requestNo = request?.requestNo;
            this.router.push({ path: `/complaint/${requestNo}` });
        },
        onCancelDialog(action: string) {
            if (action === 'cancel') {
                this.cancelPrevRequest()
            }
        },
        async cancelPrevRequest() {
            try {
                if (this.prevRequestNo) {
                    const res = await complaintService.cancelRequest(this.prevRequestNo)
                    if (res && res.status === 200) {
                        this.goCreateComplaint();
                    }
                }
            } catch (e) {
            }
        },
        displaySubTopicDialog(display: boolean) {
            this.displaySubTopic = display;
        }
    },
};
</script>
<template>
    <SubTopic v-model="displaySubTopic" :main-topic="mainTopicSelected" :sub-topic-id="subTopicSelectedId"
        :sub-topic-desc="subTopicSelectedDesc" @on-confirm="checkPreviousRequest"
        @update-sub-topic-selected-id="updateSubTopicSelectedId">
    </SubTopic>
    <!-- Confirm Continue -->
    <ConfirmDialog v-model="displayConfirmDialog" :title="$t('t-complaint-confirm-continue')"
        :text="$t('t-complaint-continue-message')" :warning-text="$t('t-complaint-cancel-request')"
        :confirm-text="'t-complaint-continue'" :cancel-text="'t-complaint-recreate'" @on-cancel="onCancelDialog"
        @on-confirm="goContinueComplaint">
    </ConfirmDialog>
</template>
